import { Typography } from "@platform/design-system";

export const EXISTING = "existing";
export const NEW = "new";
export const COVERED = "covered";
export const DUAL_OPTION = "dualOption";
export const BENEFIT_SCTRUCTURE = "benefitStructure";
export const YES = "yes";
export const NO = "no";
export const DASH = "-";
export const SELECT_THIS_OPTION = "Select This Option";
export const TOTAL_EMPLOYER_PAID = "100% Employer Paid";
export const FLAT_AMOUNT = "Flat Amount";
export const SALARY_BASED = "Salary-Based";
export const FULL_COVERED_CLASSES = "fullCoveredClasses";

export const YES_DASH_OPTIONS = [
  { label: "Yes", value: YES },
  { label: DASH, value: NO },
];

export const YES_NO_OPTIONS = [
  { label: "Yes", value: YES },
  { label: "No", value: NO },
];

export const BENEFIT_SCTRUCTURE_OPTIONS = [
  { label: FLAT_AMOUNT, value: FLAT_AMOUNT },
  { label: SALARY_BASED, value: SALARY_BASED },
];

export const COVERAGES = {
  DENTAL: { name: "dental", label: "Dental" },
  VISION: { name: "vision", label: "Vision" },
  STD: { name: "std", label: "Short Term Disability" },
  LTD: { name: "ltd", label: "Long Term Disability" },
  BASIC_LIFE: { name: "basiclife", label: "Basic Life / AD&D" },
  BASIC_LIFE_ADND: { name: "basicLifeAdnd", label: "Basic Life & AD&D" },
  VOLUNTARY_LIFE: { name: "voluntarylife", label: "Voluntary Life" },
  VOLUNTARY_AD: { name: "voluntaryad", label: "Voluntary AD&D" },
  VOLUNTARY_LIFE_ADND: {
    name: "voluntaryLifeAdnd",
    label: "Voluntary Life & AD&D",
  },
  INDIVIDUAL_DISABILITY: {
    name: "individualdisability",
    label: "Individual Disability Insurance",
  },
  STATE_DISABILITY: {
    name: "statedisability",
    label: "State Disability & Leaves",
  },
  WHOLE_LIFE: { name: "wholeLife", label: "Whole Life" },
  OTHER_COV: { name: "othercov", label: "Supplemental Health, FMLA, or EAP" },
  ACCIDENT: { name: "accident", label: "Accident" },
  CANCER: { name: "cancer", label: "Cancer" },
  CRITICAL_ILLNESS: { name: "criticalIllness", label: "Critical Illness" },
  EAP: { name: "eap", label: "EAP" },
  HOSPITAL_INDEMNITY: {
    name: "hospitalIndemnity",
    label: "Hospital Indemnity",
  },
  FMLA: { name: "fmla", label: "FMLA" },
};

export const COVERAGE_LABELS: Record<string, string> = {
  ...Object.fromEntries(
    Object.values(COVERAGES).map((cov) => [cov.name, cov.label]),
  ),
  individualDisabilityInsurance: "Individual Disability Insurance",
};

export const BASE_COVERAGES = [
  COVERAGES.INDIVIDUAL_DISABILITY.name,
  COVERAGES.STATE_DISABILITY.name,
  COVERAGES.WHOLE_LIFE.name,
  COVERAGES.OTHER_COV.name,
];

export const COVERED_COVERAGES = [
  COVERAGES.BASIC_LIFE.name,
  COVERAGES.BASIC_LIFE_ADND.name,
  COVERAGES.VOLUNTARY_LIFE.name,
  COVERAGES.VOLUNTARY_AD.name,
  COVERAGES.VOLUNTARY_LIFE_ADND.name,
];

export const DUAL_COVERAGES = [COVERAGES.DENTAL.name, COVERAGES.VISION.name];

export const TERM_DISABILITY_COVERAGES = [
  COVERAGES.LTD.name,
  COVERAGES.STD.name,
  COVERAGES.BASIC_LIFE.name,
  COVERAGES.BASIC_LIFE_ADND.name,
];

export const SECOND_QUESTION_LABELS: { [key: string]: React.ReactNode } = {
  std: (
    <Typography>
      Choose <b>&quot;Select This Option&quot;</b> below. Make sure your census
      has a <b>&quot;STD Coverage&quot;</b> column that indicates if an employee
      has coverage. This will apply for both Basic and Voluntary coverage.
    </Typography>
  ),
  ltd: (
    <Typography>
      Choose <b>&quot;Select This Option&quot;</b> below. Make sure your census
      has a <b>&quot;LTD Coverage&quot;</b> column that indicates if an employee
      has coverage. This will apply for both Basic and Voluntary coverage.
    </Typography>
  ),
};

export const IDLE = "Idle";
export const SUCCESS = "Success";
export const LOADING = "Loading";

// dropzone constants

export const CUSTOM_ACCEPTED_FORMATS = {
  "application/customTypes": [".xls", ".xlsx"],
};
export const ALLOWED_FORMATS = "XLS, XLSX";
export const MAX_SIZE = 10 * 1024 * 1024; // 10MB
export const EXCEL_VALID_TYPE = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];

export const TEMPLATE_NAME = "census-template.xlsx";

export interface IPlanName {
  label: string;
  value: string;
}

export interface ICoverageQuestionnaireItem {
  label: string;
  value: string;
  planNames?: IPlanName[];
}

export const COVERAGE_QUESTIONNAIRE: Record<
  string,
  ICoverageQuestionnaireItem[]
> = {
  [COVERAGES.DENTAL.name]: [
    {
      label: "Single PPO Only",
      value: "ppo",
    },
    {
      label: "HMO Only",
      value: "hmo",
    },
    {
      label: "Dual Option PPO Only",
      value: "dualOption",
      planNames: [
        {
          label: "PPO Low",
          value: "low",
        },
        {
          label: "PPO High",
          value: "high",
        },
      ],
    },
    {
      label: "HMO & Single PPO",
      value: "hmoPpo",
      planNames: [
        {
          label: "HMO",
          value: "low",
        },
        {
          label: "Single PPO",
          value: "high",
        },
      ],
    },
  ],
  [COVERAGES.VISION.name]: [
    { label: "Single Vision Plan", value: "singleVision" },
    {
      label: "Dual Option Vision Plan",
      value: "dualOption",
      planNames: [
        { label: "Vision Low", value: "low" },
        { label: "Vision High", value: "high" },
      ],
    },
  ],
};
